import { Container, Typography } from '@cleartrip/ct-design-components'
import React from 'react'

import HeaderImage from './header'
import { ShieldIcon } from './UIComponents'
import styles from './VdcEducationPage.module.scss'

const VdcHeader: React.FC = () => (
  <Container className={`${styles.header} flex flex-column`}>
    <Container className={`${styles['header__content']} flex flex-between`}>
      <Container className={`${styles['header__titleWrapper']} flex`}>
        <ShieldIcon />
        <Container className={`${styles['header__textContent']} flex flex-column`}>
          <Typography className={styles['header__title']} variant="HD1">Visa Rejection Cover</Typography>
          <span className={styles['header__subtitle']}>
            Full refund of flight fare in case visa gets rejected!
          </span>
          <Container className={`${styles['header__badge']} flex flex-center`}>
            ABSOLUTELY <span className={styles['header__badgeHighlight']}>FREE &nbsp;</span>ON CLEARTRIP
          </Container>
        </Container>
      </Container>
      <Container style={{ marginTop: '-64px' , marginBottom: '24px' }}>
        <HeaderImage />
      </Container>
    </Container>
  </Container>
)

export default VdcHeader
